import { lazy, Suspense } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import ScrollToTop from "./components/ScrollToTop";

const Index = lazy(() => import("./pages/Index.tsx"));
const NotFound = lazy(() => import("./pages/NotFound.tsx"));
const Hinnasto = lazy(() => import("./pages/Hinnasto.tsx"));
const Aukiolot = lazy(() => import("./pages/Aukiolot.tsx"));
const Valmennus = lazy(() => import("./pages/Valmennus.tsx"));
const Kuntosalit = lazy(() => import("./pages/Kuntosalit.tsx"));
const Hieronta = lazy(() => import("./pages/Hieronta.tsx"));
const Yhteystiedot = lazy(() => import("./pages/Yhteystiedot.tsx"));
const AdminLogin = lazy(() => import("./pages/AdminLogin.tsx"));
const AdminDashboard = lazy(() => import("./pages/AdminDashboard.tsx"));

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ScrollToTop />
          <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/hinnasto" element={<Hinnasto />} />
            <Route path="/aukiolot" element={<Aukiolot />} />
            <Route path="/valmennus" element={<Valmennus />} />
            <Route path="/kuntosalit" element={<Kuntosalit />} />
            <Route path="/hieronta" element={<Hieronta />} />
            <Route path="/yhteystiedot" element={<Yhteystiedot />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          </Suspense>
        </BrowserRouter>
      </TooltipProvider>
    </AuthProvider>
  </QueryClientProvider>
  </HelmetProvider>
);

export default App;
